// extracted by mini-css-extract-plugin
module.exports = {"quantity-container":"quantity-selector_quantity-container__swGXj","select-trigger":"quantity-selector_select-trigger__cSijx"};